import axios from "../http-common";
class API {
  index(model) {
    return axios.get(`/${model}`);
  }
  show(id, model) {
    return axios.get(`/${model}/${id}`);
  }
  destroy(id, model) {
    return axios.delete(`/${model}/${id}`);
  }
  store(data, model) {
    return axios.post(`/${model}`, data);
  }
  update(id, data, model) {
    return axios.put(`/${model}/${id}`, data);
  }
}
export default new API();
